module.exports = __webpack_public_path__ + "img/1.1b26f1a2.jpg";